// user/src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAIKllz7R5H2rkYnFteW7CrEBYrBb9FDjA",
  authDomain: "auction-c2aca.firebaseapp.com",
  projectId: "auction-c2aca",
  storageBucket: "auction-c2aca.appspot.com",
  messagingSenderId: "615014177265",
  appId: "1:615014177265:web:1c066ec3701ca3e31ccc50",
  measurementId: "G-WTM23ZM31G"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);
